import getOr from "lodash/fp/getOr";

const selectProductId = getOr("", ["app", "formData", "id"]);

export default selectProductId;
